import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import { Chart, Interval, Axis, Tooltip, Coordinate, Legend } from "bizcharts";
import DataSet from "@antv/data-set";
import DownloadButton from "../Common/DownloadButton";

const MultiLineChart = (props) => {
  const [data, setData] = useState([]);

  const filter = props.filter;

  const csv = props.csv;
  const { readString } = usePapaParse();

  const handleReadString = () => {
    readString(csv, {
      complete: (results, file) => {
        setData(results.data.filter((d) => d["Type"] === props.filter));
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        console.log("Error while parsing:", error, file);
      },
    });
  };
  const Food_Commodity_Order = [
    { name: "Bovine", order: 1 },
    { name: "Carrot", order: 2 },
    { name: "Cauliflower", order: 3 },
    { name: "Dried beans", order: 4 },
    { name: "Kiwi Fruits", order: 5 },
    { name: "Onions", order: 6 },
    { name: "Oranges", order: 7 },
    { name: "Pears", order: 8 },
    { name: "Potatoes", order: 9 },
    { name: "Poultry", order: 10 },
    { name: "Rice", order: 11 },
    { name: "Rye", order: 12 },
  ];

  const getCommodityOrder = (commodity) => {
    const found = Food_Commodity_Order.find((f) => f.name === commodity);
    if (found) {
      return found.order;
    }
    return 0;
  };
  useEffect(() => {
    handleReadString();
  }, [filter]);

  // let transform = [];
  //   data.forEach((d) => {
  //   const a = {
  //     "Food commodity": d["Food commodity"],
  //     2017: d["2017"] === null ? "0" : d["2017"],
  //   };
  //   const b = {
  //     "Food commodity": d["Food commodity"],
  //     2020: d["2020"] === null ? "" : d["2020"],
  //   };
  //   const c = {
  //     "Food commodity": d["Food commodity"],
  //     2023: d["2023"] === null ? "" : d["2023"],
  //   };
  //   transform = transform.concat([a, b, c]);
  // });

  

  let transform = [];
data.forEach((d) => {
  const a = {
    "Food commodity": d["Food commodity"],
    type: "2018",
    value: d["2018"] ?? 0, // Ensure no undefined values
  };
  const b = {
    "Food commodity": d["Food commodity"],
    type: "2021",
    value: d["2021"] ?? 0,
  };
  const c = {
    "Food commodity": d["Food commodity"],
    type: "2024",
    value: d["2024"] ?? 0,
  };
  transform = transform.concat([a, b, c]);
});




  const ds = new DataSet();
const dv = ds.createView().source(
  transform.sort((a, b) => a["Food commodity"].localeCompare(b["Food commodity"]))
);



  //dv.rows.sort((a, b) => (getCommodityOrder(a["Food commodity"]) < getCommodityOrder(b["Food commodity"]) ? -1 : 1))
  const [canvas, setCanvas] = useState(undefined);
  const scale = {
  value: {
    min: 0,
    max: 90,  // Ensure it always shows up to 80% even when only 2017 is selected
    tickInterval: 20, // Force axis labels at 0%, 20%, 40%, 60%, 80%
    nice: false, // Prevent automatic scaling when data changes
  },
};

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <p
          className="titleChart"
          style={{
            marginBottom: "1.1rem",
            fontFamily: "Roboto Condensed, sans-serif",
            width: "100%",
          }}
        >
          MRL exceedance rates comparison (2018, 2021, 2024)
        </p>
        <DownloadButton canvas={canvas} fileName={"Chart"} csv={data} />
      </Box>
      
      <Chart
        padding={[15, 20, 70, 110]}
        height={500}
        data={dv}
        scale={scale}
        autoFit
        onGetG2Instance={(chartInstance) => {
          setTimeout(() => {
            setCanvas(chartInstance.canvas);
          }, 1000);
        }}
      >
        <Coordinate transpose scale={[1, -1]} />
        <Axis
          name="Food commodity"
          label={{
            offset: 12,
            style: {
              fontFamily: "Roboto Condensed, sans-serif",
            },
          }}
        />
        <Axis
  name="value"
  position="right"  // Change position to bottom for better visibility
  label={{
    formatter: (val) => `${val}%`, // Always show percentage
  }}
  tickLine={{
    length: 5, // Small tick marks to force labels to stay
  }}
  grid={{
    line: {
      style: {
        stroke: "#ddd", // Keep grid lines visible
        lineWidth: 1,
        lineDash: [4, 4], // Dashed lines for clarity
      },
    },
  }}
/>

        <Tooltip shared showCrosshairs={true}>
  {(title, items) => {
    return (
      <div
        id="#tooltipWrap"
        style={{
          padding: "5px 10px 10px 5px",
          width: "auto",
          color: "#22294D",
          fontFamily: "Roboto Condensed",
        }}
      >
        <div className="g2-tooltip-title" style={{ fontWeight: "bold" }}>
          {title}
        </div>
        <ul className="g2-tooltip-list">
          {items.map((item, index) => (
            <li key={index} style={{ padding: "2px 0" }} data-index={index}>
              <span
                style={{
                  backgroundColor: item.color,
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  display: "inline-block",
                  marginRight: "8px",
                }}
              />
              {item.name}: {item.value !== undefined ? `${Math.round(item.value * 10) / 10}%` : "-"}
            </li>
          ))}
        </ul>
      </div>
    );
  }}
</Tooltip>

        <Interval
  position="Food commodity*value"
  color={["type", ["#90B1CE", "#23649E", "#22294D"]]} 

  adjust={dv.rows.filter(d => d.type).length > 1 ? [{ type: "dodge", marginRatio: 1 / 32 }] : []}
/>

      </Chart>
    </Box>
  );
};

export default MultiLineChart;
